export function getTokenFromLocalStorage(): string {
  const data = localStorage.getItem('access_token');
  if (!data) return '';

  // Проверяем, является ли это JSON строкой или обычной строкой
  try {
    // Если это JSON строка (обернутая в кавычки), парсим её
    const parsed = JSON.parse(data);
    return typeof parsed === 'string' ? parsed : '';
  } catch {
    // Если это не JSON, возвращаем как есть (обычная строка)
    return data;
  }
}

export function getRefreshTokenFromLocalStorage(): string {
  const data = localStorage.getItem('refresh_token');
  if (!data) return '';

  // Проверяем, является ли это JSON строкой или обычной строкой
  try {
    // Если это JSON строка (обернутая в кавычки), парсим её
    const parsed = JSON.parse(data);
    return typeof parsed === 'string' ? parsed : '';
  } catch {
    // Если это не JSON, возвращаем как есть (обычная строка)
    return data;
  }
}

export function setItemToLacalStorage(key: string, token: string): void {
  localStorage.setItem(key, JSON.stringify(token));
}

export function removeTokenFromLocalStorage(key: string): void {
  localStorage.removeItem(key);
}

export function removeAllTokens(): void {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
}
